module.exports = __webpack_public_path__ + "img/qr-wrapper.c028582c.png";